import { FC } from "react";
import { SystemEvent } from "../../../domain/models/SystemEvent";
import SystemEventTableRow from "./SystemEventTableRow";
import { SystemEventFields } from "../../../domain/enums/SystemEventFieldsEnum";
import { enumToSelectProps } from "../../../tools/EnumTools";
import { useTranslation } from "react-i18next";

interface SystemEventsTableProps {
    systemEvents: SystemEvent[];
    updateHandler?: (systemEvent: SystemEvent) => void;
}

const SystemEventsTable: FC<SystemEventsTableProps> = (props) => {
    const { t } = useTranslation();

    return (
        <div className="w-[95%] h-[calc(100vh-150px)] ml-auto mr-auto relative overflow-auto bg-light-bg-700 dark:bg-dark-bg-800 rounded-xl shadow-lightTable dark:shadow-darkTable">
            <table className="w-full text-sm text-left text-light-text-100 dark:text-dark-text-100">
                <thead className="sticky top-0 text-[14px] font-extralight leading-[16px] text-light-text-100 dark:text-dark-text-100 bg-light-bg-800 dark:bg-dark-bg-900">
                    <tr className="text-center px-2 py-3 group relative">
                        {Object.values(enumToSelectProps(SystemEventFields, "console.systemEvents.table")).map((value) => (
                            <th
                                key={`th-system-events-table-${value.labelKey}`}
                                className="px-2 py-3 group border-x border-y-0 border-light-border-200 dark:border-dark-border-200 bg-light-bg-800 dark:bg-dark-bg-900"
                            >
                                {t(value.labelKey)}
                            </th>
                        ))}
                        {/* Додаємо колонку для дій, якщо потрібно */}
                        {props.updateHandler && (
                            <th className="px-2 py-3 group border-x border-y-0 border-light-border-200 dark:border-dark-border-200 bg-light-bg-800 dark:bg-dark-bg-900">
                                {t("console.systemEvents.table.actions")}
                            </th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {props.systemEvents.map((systemEvent) => (
                        <SystemEventTableRow
                            key={`tr-system-event-table-${systemEvent.id}`}
                            systemEvent={systemEvent}
                            updateHandler={props.updateHandler}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SystemEventsTable;
